export type {
  ClientPreferenceItem,
  ClientPreferencePatchItem,
  ClientPreferencesPayload,
  ClientMarketingPreferenceKey,
} from './lib/models/client-preferences.models';
export {
  CLIENT_PREFERENCE_KEYS,
  CLIENT_MARKETING_PREFERENCE_KEYS,
} from './lib/models/client-preferences.models';
export { COMMUNICATIONS_PREFERENCES_I18N } from './lib/constants/communications-preferences-i18n.constants';
export {
  ClientPreferencesService,
  DEV_SMS_PREFERENCES_MODE_SESSION_KEY,
  type SmsPreferencesDevMode,
} from './lib/client-preferences/client-preferences.service';
export { SmsPromptService } from './lib/sms-prompt/sms-prompt.service';
export { SettingsCommunicationsSectionComponent } from './lib/settings-communications/settings-communications-section.component';
